import React, {Component} from 'react';
import {push} from 'react-router-redux';
import {connect} from 'react-redux';
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import NavigationRefresh from 'material-ui/svg-icons/navigation/refresh';
import RaisedButton from 'material-ui/RaisedButton';

class PageNotFoundView extends Component {

   constructor(props) {
      super(props);

      const {location} = props;
      let badUrl = '';
      if (!!location && !!location.state && !!location.state.referrer){
         badUrl = location.state.referrer;
      }
      const badUrlVisible = !!badUrl && badUrl !== '';

      this.state = {
         url: badUrl,
         urlVisible: badUrlVisible,
         urlRequired: '',
         urlColor: 'rgb(224, 0, 0)'
      };
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleRefreshPageBtn = this.handleRefreshPageBtn.bind(this);
      this.handleBackToHomeBtn = this.handleBackToHomeBtn.bind(this);
   }

   handleInputChange(event) {
      const target = event.target;
      const value = target.value;
      const {urlRequired} = this.state;
      const {location} = this.props;

      var oldValue = location.state.referrer;
      if (value !== '' && urlRequired !== ''){
         this.setState({
            urlRequired: ''
         });
      }
      if (oldValue !== value){
         this.setState({
            url: value,
            urlColor: 'rgb(0, 212, 28)'
         });
      }
   }

   handleBackToHomeBtn(event) {
      const {dispatch} = this.props;
      dispatch(push('/'));
   }

   handleRefreshPageBtn(event) {
      const {dispatch} = this.props;
      const {url}= this.state;
      if (url === '') {
         const reqMsg = 'This is a required field';
         this.setState({
            urlRequired: reqMsg
         });
      } else {
         dispatch(push(url));
      }
   }

   render() {
      const {url, urlVisible, urlRequired, urlColor} = this.state;
      const cardStyle = {
         maxWidth: 900,
         height: urlVisible ? 280 : 260,
         padding: 30,
         textAlign: 'center',
         margin: 'auto',
         marginTop: '10%',
         position: 'absolute',
         top: 0,
         right: 0,
         bottom: 0,
         left: 0
      };
      const hintStyle = {
         fontSize: 18
      }
      return (
         <div>
            <div style={cardStyle}>
               <h1 style={{color:'rgb(224, 0, 0)', fontSize: 56}}>404 ERROR!</h1>
               <h3 style={{color:'rgb(0, 188, 212)'}}>For Some Reason The Page You Requested Could Not Be Found On Our Server</h3>
               {urlVisible ?
                  <div>
                     <div>
                        <TextField
                           name="url"
                           hintText="Not Found Url"
                           value={url}
                           onChange={this.handleInputChange}
                           errorText={urlRequired}
                           style={{fontSize:18,minWidth:440}}
                           inputStyle={{textAlign: 'center',color: urlColor}}
                           hintStyle={{textAlign: 'center', width: '100%'}}
                        />
                        <IconButton tooltip="Page Reload" onTouchTap={this.handleRefreshPageBtn}>
                           <NavigationRefresh color='rgb(255, 64, 129)'/>
                        </IconButton>
                     </div>
                     <br/>
                     <span style={hintStyle}>Please correct your url or back to home</span>
                  </div> : ''
               }
               <div style={{width:'100%',marginTop:30}}>
                  <RaisedButton label="Back to home" secondary={true} onTouchTap={this.handleBackToHomeBtn}/>
               </div>
            </div>
         </div>
      );
   }
}

export default connect()(PageNotFoundView);


// WEBPACK FOOTER //
// ./src/views/PageNotFoundView.js